import React, { useMemo } from "react"
import { EditBandFormField } from "./EditBandFormField"
import { handleUpdateBandData } from "../BandEditPage"
import { Band } from "../../types/bands"
import { useBandEditForm } from "./BandEditFormContext"

interface EntranceInstructionsProps {
  band: Band
}

interface ApiResponse {
  success: boolean
  errors?: {
    error: string
  }
}

export const EntranceInstructions: React.FC<EntranceInstructionsProps> = ({
  band,
}) => {
  const { form } = useBandEditForm()
  const isLocationSecret = form.watch("additional_info.is_location_secret")

  const customOnSubmit = async (
    data: Record<string, any>,
  ): Promise<ApiResponse> => {
    // data will be { additional_info: { entrance_instructions: value } } from EditBandFormField
    return (await handleUpdateBandData(band.id, {
      additional_info: { entrance_instructions: data.additional_info?.entrance_instructions || null },
    })) as ApiResponse
  }

  const fieldData = useMemo(
    () => ({
      field: "additional_info.entrance_instructions",
      name: "entranceInstructions",
      label: "Entrance Instructions",
      placeholder: "Enter entrance instructions...",
      required: false,
      notes:
        isLocationSecret === "after_validation"
          ? "Entrance instructions will only be shown after user has been verified"
          : null,
    }),
    [isLocationSecret],
  )

  return (
    <EditBandFormField
      type="textarea"
      fieldData={fieldData}
      bandId={band.id}
      onSubmit={customOnSubmit}
    />
  )
}
